<template>
   <mu-infinite-scroll :loading="load" loadingText="正在跳转···" class="load" v-if="load" />
</template>
<script type="application/ecmascript">
import Constant from '@/Constant';
 import util from "@common/utils/util.js";
import {
    mapActions,
    mapGetters
} from 'Vuex';

export default {
        data() {
            return {
                load:true,
            }
        },
        created() {
            this.login();
        },
        methods: {
            ...mapActions({
                saveWxLogin: 'saveWxLogin',
                doLogin:'doLogin',
                connectOauth2Authorize:'connectOauth2Authorize',//5.2.生成微信网页授URL-用户同意授权获取code
                doWxMpLogin:'doWxMpLogin',
                updateMemCartForUserLogin:'updateMemCartForUserLogin'
            }),
            login() {
                let code = this.$route.query['code'] || util.parseString(location.href,'&','code');
                //alert('CODE：'+code);
                //微信浏览器内，必须获取到CODE   && Constant.env.ENV_MODE == 'production'
                if(!code && this.util.isWeiXin()){
                    //alert('您是微信浏览器，必须获取CODE，将跳转至微信服务器...');
                   return this.doWxOauth2AutoLogin(); 
                }

                this.toLoginPage(code);
            },

            toLoginPage(code){
                let redirect = this.$route.query.redirect;
                let isQuestionLogin = this.$route.query.isQuestionLogin;
                //当前是大区问卷调查时跳转到wxLogin界面，否则跳转商城登录界面
                let pathUrl = isQuestionLogin == 'true' ? '/main/questionLogin' : '/main/login';
                this.$router.push({
                    path: pathUrl,
                    query: {
                        'redirect' : redirect,
                        'code':code
                    }
                })
            },

            // 请求微信授权登陆
            doWxOauth2AutoLogin() {
                let redirectURL = this.$route.query.redirect || "";
                let prevFix = redirectURL.includes("?") ? "&autologin=true" : "?autologin=true";
                redirectURL += prevFix;

                this.connectOauth2Authorize([redirectURL]).then(res=>{
                    //alert('微信授权结果： doWxAutoLogin- '+JSON.stringify(res.target));
                    if(res.target){
                        // 重定向至微信
                        let url = res.target;
                        
                        //alert('oauth2 授权后的URL >>> ' + url);
                        location.replace(url); 
                    }
                })             
            },

            // 微信CODE登陆
            wxMemLoginByCode(code){
                //alert("code:"+code)
                this.doWxMpLogin([code]).then(res=>{
                    //alert("doWxMpLogin-"+ JSON.stringify(res));
                    if (res.success && res.target && res.target.success) {
                        let memData = res.target.target;
                        //alert("memData-"+ JSON.stringify(memData));
                        
                        //调用loginCall/login方法，注册用户登录状态
                        this.doLogin({
                            openId: memData.openId,
                            clientType:'WEIXIN',
                            authToken: memData.authToken
                        }).then(res=>{
                            //alert("调用loginCall-"+res)
                            let redirect = decodeURIComponent(this.$route.query.redirect || '/');
                            this.updateMemCartForUserLogin();
                            //完整URL
                            if(redirect.startsWith('http')){
                                location.href = redirect;
                            }else{
                                this.$router.push({
                                    path: redirect
                                })
                            }
                        })
                    } else {
                        //alert('微信CODE登录失败： '+(res && (res.message || res.target.message))|| "微信自动登录失败");
                        this.toLoginPage();
                    }
                }).catch(err => {
                    //alert('微信CODE登录失败： '+JSON.stringify(err));
                    this.toLoginPage();
                })
            }
        }
}
</script>
<style scoped lang='scss' rel="stylesheet/scss" type="text/css">
</style>



// WEBPACK FOOTER //
// auth.vue?0ebe3be4